








































import Vue from "vue";
import RoomWizard from "@/components/organisms/wizard/RoomWizard.vue";
import WizardConnect from "@/components/organisms/wizard/WizardConnect.vue";
import { DeviceConfiguration } from "@/models/deviceConfiguration";
import {
  getWizardExternalConfig,
  WizardExternalConfig,
} from "@/services/externalProvidersService";
import VaButton from "@/components/atoms/VaButton.vue";
import SingleColumn from "@/components/templates/SingleColumn.vue";
import InfoViewer from "@/components/organisms/InfoViewer.vue";
import LightSwitcher from "@/components/organisms/LightSwitcher.vue";
import AuthService from "@/services/authService";

export default Vue.extend({
  name: "template_main",
  data() {
    return {
      deviceConfiguration: undefined as DeviceConfiguration | undefined,
    };
  },
  methods: {
    onConfigUpdated(config: DeviceConfiguration) {
      this.deviceConfiguration = config;
    },
    onLogout(): void {
      this.$store.commit("session/setBackUrl", "/activate-tab");
      AuthService.logout();
    },
  },
  computed: {
    wizardExternalConfig(): WizardExternalConfig {
      return getWizardExternalConfig(
        this.deviceConfiguration?.clientConfig?.wizardSetting
      );
    },
    steps(): string[] {
      let steps = ["license", "appearance"];
      if (this.deviceConfiguration?.deviceType === "Room") {
        steps = ["license", "updates", "credentials", "language", "appearance"];
      }
      if (this.wizardExternalConfig.hasCalendar) steps.push("calendar");
      if (this.wizardExternalConfig.hasMeeting) steps.push("meeting");
      steps.push("complete");
      return steps;
    },
  },
  components: {
    VaButton,
    WizardConnect,
    RoomWizard,
    SingleColumn,
    InfoViewer,
    LightSwitcher,
  },
});
